import { Injectable } from '@angular/core';
import { LoginData } from './service/modal/login';
import { UtilFunctions } from './util-functions';
import { Attachment } from './service/modal/approved';

Injectable()
export class Globals {
  public static attachmentStatus: boolean = false;
  // G_apiUrl = "https://13.235.145.174:9091/DigiLocker";
  G_apiUrl = "https://mdhl.in:9091/DigiLocker";
  
    // G_apiUrl = "https://192.168.0.6:9091/DigiLocker";

  loggedUser: LoginData = new LoginData();
  sharehealthCard: String = new String;
  switchProfileStr: String = new String;
  buyNowButtonClick:boolean;
  refreshCount = 0;
  loginCount = 0;
 excelFilePath="https://mdhl.s3.ap-south-1.amazonaws.com/multiUserRegister.xlsx";
 excelFilePathBlankFile="https://mdhl.s3.ap-south-1.amazonaws.com/multiUserRegisterBlank.xlsx";
firebaseToken="";

  afterRefreshPageSetToken() {
    const user = JSON.parse(UtilFunctions.getLocalStorage('user'));
    this.loggedUser = user;
    if (user) {
      return;
    }
    // this.router.navigate(['/login']);
  }
  // incrementrefreshCount() {
  //   return ++this.refreshCount;
  // }
}
